<template>
    <div class="min-h-[350px]">
        <div
            :class="[
                'min-h-[6rem] p-4 w-full group flex space-x-5 justify-between items-center border-2 border-gray-400 border-solid rounded-md mb-4 hover:cursor-pointer hover:shadow-md hover:border-primary-400',
                option === 'cambio' && 'border-primary-400',
            ]"
            @click="setOption('cambio')"
        >
            <div class="flex items-center">
                <Icon size="30">
                    <ArrowsLeftRight />
                </Icon>
                <div>
                    <label
                        :for="'servicio'"
                        class="block ml-2 font-medium text-gray-700 group-hover:cursor-pointer"
                    >
                        Solicitar cambio
                    </label>
                    <label
                        class="block ml-2 text-[12px] font-medium text-gray-700 group-hover:cursor-pointer"
                    >
                        Devolver envío a sucursal y crear envío nuevo
                    </label>
                </div>
            </div>
            <div class="flex items-center space-x-2">
                <input
                    id="cambio"
                    type="radio"
                    value="cambio"
                    class="w-4 h-4 flex items-center justify-center border-gray-300 group-hover:cursor-pointer focus:ring-2 focus:ring-primary-300"
                    v-model="option"
                />
            </div>
        </div>
        <div
            :class="[
                'min-h-[6rem] p-4 w-full group flex space-x-5 justify-between items-center border-2 border-gray-400 border-solid rounded-md mb-4 hover:cursor-pointer hover:shadow-md hover:border-primary-400',
                option === 'devolucion' && 'border-primary-400',
            ]"
            @click="setOption('devolucion')"
        >
            <div class="flex items-center">
                <Icon size="30">
                    <ArrowNarrowLeft />
                </Icon>
                <div>
                    <label
                        :for="'servicio'"
                        class="block ml-2 font-medium text-gray-700 group-hover:cursor-pointer"
                    >
                        Solicitar devolución
                    </label>
                    <label
                        class="block ml-2 text-[12px] font-medium text-gray-700 group-hover:cursor-pointer"
                    >
                        Crear envío de devolución a sucursal
                    </label>
                </div>
            </div>
            <div class="flex items-center space-x-2">
                <input
                    id="devolucion"
                    type="radio"
                    value="devolucion"
                    class="w-4 h-4 flex items-center justify-center border-gray-300 group-hover:cursor-pointer focus:ring-2 focus:ring-primary-300"
                    v-model="option"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from "@vicons/utils";
import { ArrowsLeftRight, ArrowNarrowLeft } from "@vicons/tabler";

export default {
    name: "MultistepOptions",
    components: {
        Icon,
        ArrowsLeftRight,
        ArrowNarrowLeft,
    },
    emits: ["optionSelected"],
    data() {
        return {
            option: null,
        };
    },
    mounted() {
        this.option = null;
    },
    methods: {
        setOption(option) {
            this.option = option;
            this.$emit("optionSelected", this.option);
        },
    },
};
</script>

<style>
/* :class="[
    'min-h-[6rem] p-4 w-full group flex space-x-5 justify-between items-center border-2 border-gray-400 border-solid rounded-md mb-4 hover:cursor-pointer hover:shadow-md hover:border-primary-400',
    option === 'cambio' && 'border-primary-400',
]" */
</style>
